import type { CSSProperties } from "react";

export type PictureData = {
  sources: Record<string, string>;
  img: { src: string; w: number; h: number };
};

type Props = {
  pic: PictureData;
  alt: string;
  sizes: string;
  className?: string;
  style?: CSSProperties;
  width?: number;
  height?: number;
  loading?: "lazy" | "eager";
  fetchPriority?: "high" | "low" | "auto";
  decorative?: boolean;
};

/** <picture> com AVIF/WebP em várias larguras (gerados no build). */
export function Picture({
  pic,
  alt,
  sizes,
  className,
  style,
  width,
  height,
  loading = "lazy",
  fetchPriority,
  decorative,
}: Props) {
  return (
    <picture className="contents">
      {Object.entries(pic.sources).map(([format, srcSet]) => (
        <source key={format} type={`image/${format}`} srcSet={srcSet} sizes={sizes} />
      ))}
      <img
        src={pic.img.src}
        alt={alt}
        aria-hidden={decorative ? true : undefined}
        width={width ?? pic.img.w}
        height={height ?? pic.img.h}
        loading={loading}
        decoding="async"
        fetchPriority={fetchPriority}
        className={className}
        style={style}
      />
    </picture>
  );
}
